import { useTranslation } from 'react-i18next';
import { XCircle } from 'lucide-react';

/**
 * Rejected state (QA round-2 finding 1) — a permanent FFC decline. Distinct
 * from suspended (temporary) and from State B (activation underway): a
 * declined merchant must not be told to visit a branch or that activation is
 * in progress. Directs them to their account manager / support instead.
 */
function AdvanceRejectedCard() {
  const { t } = useTranslation();
  return (
    <div
      className='mx-auto mt-2 max-w-[720px] rounded-2xl border border-solid border-[#F1C6BE] bg-[#FBEAE7] px-10 py-9'
      data-testid='advance-cod-rejected-card'
    >
      <div className='flex items-center gap-3'>
        <span className='inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#F7D6CF]'>
          <XCircle className='h-[22px] w-[22px] text-[#C0392B]' strokeWidth={2} />
        </span>
        <div>
          <div className='text-[19px] font-extrabold tracking-[-0.3px] text-[#8A2A1E]'>
            {String(t('advance_cod_rejected_card_title'))}
          </div>
          <div className='mt-1 text-[13.5px] leading-[1.5] text-[#9A5449]'>
            {String(t('advance_cod_rejected_card_body'))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdvanceRejectedCard;
